import { CostLabel, IconText, TriggerGains } from './Amount';
const { Modal } = require('react-bootstrap');

// Section titles for the kinds of action a choice can be (e.g. an action card that can build or upgrade)
const SectionTitles = {
    Build: "Build",
    Upgrade: "Upgrade",
    DiscoverTechnology: "Develop",
    IncreasePopulation: "Increase Population",
    BuildWonderStage: "Build Wonder",
};

// A dialog of buttons, one per way to do something (e.g. the buildings an action card can be used on), each looking
// like the action's usual button with its cost. Options are split into sections by the kind of action
// (option.move.inner.type: builds, then upgrades, ...); clicking one does it, Cancel closes.
function ChoiceDialog({Title, Options, ButtonClass, OnChoose, OnCancel})
{
    const sections = [];
    Options.forEach(option => {
        const kind = option.move.inner?.type ?? null;
        const section = sections.find(s => s.kind === kind);
        if (section)
        {
            section.options.push(option);
        } else {
            sections.push({ kind, title: SectionTitles[kind], options: [option] });
        }
    });

    return (
        <Modal show onHide={OnCancel} centered dialogClassName="tta-choice-dialog">
            <Modal.Header closeButton style={{ padding: '8px 12px' }}>
                <Modal.Title style={{ fontSize: '16px', fontWeight: 'bold' }}>{Title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="tta tta-left" style={{ padding: '12px' }}>
                {sections.map(section =>
                    <div key={section.kind ?? 'choices'} className="tta-choice-section">
                        {section.title && sections.length > 1 && <div className="tta-choice-title">{section.title}</div>}
                        <div className="tta-choice-buttons">
                            {section.options.map((option, index) =>
                                <button key={index} className={ButtonClass} disabled={option.disabled} title={option.reason}
                                    onClick={() => OnChoose(option)}>
                                    <IconText text={option.label}/>
                                    {option.cost && <span className="tta-button-cost"> · <CostLabel cost={option.cost}/></span>}
                                    {option.costNote && <span className="tta-cost-note"> ({option.costNote})</span>}
                                    <TriggerGains Gains={option.gains}/>
                                </button>)}
                        </div>
                    </div>)}
            </Modal.Body>
            <Modal.Footer className="tta" style={{ padding: '6px 12px' }}>
                <button className="tta-button" onClick={OnCancel}>Cancel</button>
            </Modal.Footer>
        </Modal>
    );
}

export default ChoiceDialog;
